import { Component, Input } from '@angular/core';
import { HeaderContentConfig } from './header-content.constants';

@Component({
  selector: 'header-content',
  templateUrl: './header-content.component.html',
  styleUrls: ['./header-content.component.scss'],
})
export class HeaderContentComponent {
  @Input()
  public set config(config: HeaderContentConfig) {
    this._config = new HeaderContentConfig(config);
  }

  public get config(): HeaderContentConfig {
    return this._config;
  }

  _config: HeaderContentConfig;
}
